import type { ClientAddress } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { Text } from 'react-native-paper';

export const Address: FC<ClientAddress> = ({ name, street, zip, city }) => (
  <Text variant="labelLarge" style={{ maxWidth: '80%' }}>
    {name ?? <>{[street, [zip, city].join(' ')].join(', ')}</>}
  </Text>
);
